module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    class: _vm.componentClass
  }, [(!_vm.legalCaseExists || !_vm.parentModal) ? _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.newTab
    }
  }, [_vm._v("Object")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.rTab
    }
  }, [_vm._v("Related Items")])])])]) : _c('div', [_c('ul', {
    staticClass: "nav nav-pills"
  }, [_c('li', {
    staticClass: "nav-item active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.newTab
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": '#' + _vm.existingTab
    }
  }, [_vm._v("Existing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": _vm.newTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": _vm.artifactTypeDisplay,
      "Index": "0",
      "hideHeader": !_vm.documentArtifactIdExists
    }
  }, [_c('div', {
    staticClass: "tab-pane fade in active li-top-buffer",
    attrs: {
      "id": _vm.objectTab
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Document Type")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.document_type),
      expression: "document_artifact.document_type"
    }],
    ref: "setArtifactType",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "document_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.documentArtifactTypes), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                              " + _vm._s(option.display) + "\n                                            ")])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "control-label pull-left",
    attrs: {
      "for": "Name"
    }
  }, [_vm._v("Document")])]), _vm._v(" "), (!_vm.documentArtifactId) ? _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    ref: "default_document",
    attrs: {
      "name": "default-document",
      "isRepeatable": true,
      "documentActionUrl": "temporary_document"
    },
    on: {
      "update-temp-doc-coll-id": _vm.setTemporaryDocumentCollectionId
    }
  })], 1) : _c('div', {
    staticClass: "col-sm-9"
  }, [_c('filefield', {
    key: _vm.documentArtifactId,
    ref: "document_artifact_documents",
    attrs: {
      "name": "document-artifact-documents",
      "isRepeatable": true,
      "documentActionUrl": _vm.document_artifact.defaultDocumentUrl,
      "readonly": _vm.readonlyForm
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Identifier")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.identifier),
      expression: "document_artifact.identifier"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.document_artifact.identifier)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "identifier", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.statementVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Statement")])]), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.statement_id),
      expression: "document_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.legal_case.statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                            ")])
  }), 0)]) : _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.statement_id),
      expression: "document_artifact.statement_id"
    }],
    ref: "setStatement",
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "statement_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.document_artifact.available_statement_artifacts), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [_vm._v("\n                                            " + _vm._s(option.document_type_display) + ": " + _vm._s(option.identifier) + "\n                                            ")])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.offenceVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offence")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.offence_id),
      expression: "document_artifact.offence_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "offence_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        $event.preventDefault();
        return _vm.setOffenderId(null)
      }]
    }
  }, _vm._l((_vm.legal_case.offence_list), function(option) {
    return _c('option', {
      key: option.id,
      domProps: {
        "value": option.id
      }
    }, [(option.id) ? _c('div', [_vm._v("\n                                                    " + _vm._s(option.lodgement_number) + ": " + _vm._s(option.identifier) + "\n                                                ")]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.offenceVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Offender")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.offender_id),
      expression: "document_artifact.offender_id"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.document_artifact, "offender_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.offenderList), function(option) {
    return _c('option', {
      key: option.offender_id,
      domProps: {
        "value": option.offender_id
      }
    }, [(option.id) ? _c('div', [_vm._v("\n                                                " + _vm._s(option.full_name) + ": " + _vm._s(option.email) + "\n                                            ")]) : _vm._e()])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Description")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.description),
      expression: "document_artifact.description"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": _vm.readonlyForm
    },
    domProps: {
      "value": (_vm.document_artifact.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "description", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.personProvidingStatementVisibility) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.personProvidingStatementLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('SearchPersonOrganisation', {
    key: _vm.updateSearchPersonOrganisationBindId,
    ref: "document_artifact_search_person_organisation",
    attrs: {
      "parentEntity": _vm.personProvidingStatementEntity,
      "personOnly": "",
      "isEditable": !_vm.readonlyForm,
      "classNames": "form-control",
      "showCreateUpdate": "",
      "addFullName": "",
      "displayTitle": false,
      "domIdHelper": "document_artifact",
      "departmentalStaff": ""
    },
    on: {
      "entity-selected": _vm.setPersonProvidingStatement
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interviewerVisibility),
      expression: "interviewerVisibility"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.interviewerLabel))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('select', {
    ref: "document_artifact_interviewer",
    staticClass: "form-control",
    attrs: {
      "id": "document_artifact_interviewer",
      "name": "document_artifact_interviewer"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactDatePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.artifact_date),
      expression: "document_artifact.artifact_date"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.document_artifact.artifact_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "artifact_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-3"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    ref: "artifactTimePicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.document_artifact.artifact_time),
      expression: "document_artifact.artifact_time"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.readonlyForm,
      "type": "text",
      "placeholder": "HH:MM"
    },
    domProps: {
      "value": (_vm.document_artifact.artifact_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.document_artifact, "artifact_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])])])])])])])])], 1), _vm._v(" "), (_vm.parentModal) ? _c('div', {
    staticClass: "tab-pane fade in li-top-buffer",
    attrs: {
      "id": _vm.existingTab
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "existing_artifact_table",
    attrs: {
      "id": "existing-artifact-table",
      "dtOptions": _vm.dtOptions,
      "dtHeaders": _vm.dtHeaders
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.parentModal) ? _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": _vm.rTab
    }
  }, [_c('FormSection', {
    attrs: {
      "formCollapse": false,
      "label": "Related Items"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.relatedItemsVisibility) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('RelatedItems', {
    key: _vm.relatedItemsBindId,
    attrs: {
      "parent_update_related_items": _vm.setRelatedItems,
      "readonlyForm": _vm.readonlyForm,
      "parentComponentName": "document_artifact"
    }
  })], 1) : _vm._e()])])])], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-850dc144"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/document_artifact_component.vue
// module id = 1026
// module chunks = 0